export const areaCodeList = {
  "#": [
    {
      name: "中国",
      code: "+86",
      engName: "China",
      index: "43",
      firstWord: "Z",
      shouzimu: "ZGDL",
      hot: true
    },
    {
      name: "中国香港",
      code: "+852",
      engName: "Hong Kong",
      index: "97",
      firstWord: "Z",
      shouzimu: "ZGXG",
      hot: true
    },
    {
      name: "中国澳门",
      code: "+853",
      engName: "Macao",
      index: "140",
      firstWord: "Z",
      shouzimu: "ZGAM",
      hot: true
    },
    {
      name: "中国台湾",
      code: "+886",
      engName: "Taiwan",
      index: "233",
      firstWord: "Z",
      shouzimu: "ZGTW",
      hot: true
    }
  ],
  A: [
    {
      name: "阿鲁巴",
      code: "+297",
      engName: "Aruba",
      index: "1",
      firstWord: "A",
      shouzimu: "ALB"
    },
    {
      name: "阿富汗",
      code: "+93",
      engName: "Afghanistan",
      index: "2",
      firstWord: "A",
      shouzimu: "AFH"
    },
    {
      name: "安哥拉",
      code: "+244",
      engName: "Angola",
      index: "3",
      firstWord: "A",
      shouzimu: "AGL"
    },
    {
      name: "安圭拉",
      code: "+1264",
      engName: "Anguilla",
      index: "4",
      firstWord: "A",
      shouzimu: "AGL"
    },
    {
      name: "阿尔巴尼亚",
      code: "+355",
      engName: "Albania",
      index: "5",
      firstWord: "A",
      shouzimu: "AEBNY"
    },
    {
      name: "奥兰群岛",
      code: "+358",
      engName: "Aland",
      index: "6",
      firstWord: "A",
      shouzimu: "ALQD"
    },
    {
      name: "安道尔",
      code: "+376",
      engName: "Andorra",
      index: "7",
      firstWord: "A",
      shouzimu: "ADE"
    },
    {
      name: "阿联酋",
      code: "+971",
      engName: "United Arab Emirates",
      index: "8",
      firstWord: "A",
      shouzimu: "ALQ"
    },
    {
      name: "阿根廷",
      code: "+54",
      engName: "Argentina",
      index: "9",
      firstWord: "A",
      shouzimu: "AGT"
    },
    {
      name: "安提瓜和巴布达",
      code: "+1268",
      engName: "Antigua and Barb.",
      index: "15",
      firstWord: "A",
      shouzimu: "ATGHBBD"
    },
    {
      name: "澳大利亚",
      code: "+61",
      engName: "Australia",
      index: "16",
      firstWord: "A",
      shouzimu: "ADLY"
    },
    {
      name: "奥地利",
      code: "+43",
      engName: "Austria",
      index: "17",
      firstWord: "A",
      shouzimu: "ADL"
    },
    {
      name: "阿塞拜疆",
      code: "+994",
      engName: "Azerbaijan",
      index: "18",
      firstWord: "A",
      shouzimu: "ASBJ"
    },
    {
      name: "阿尔及利亚",
      code: "+213",
      engName: "Algeria",
      index: "67",
      firstWord: "A",
      shouzimu: "AEJLY"
    },
    {
      name: "埃及",
      code: "+20",
      engName: "Egypt",
      index: "69",
      firstWord: "A",
      shouzimu: "AJ"
    },
    {
      name: "爱沙尼亚",
      code: "+372",
      engName: "Estonia",
      index: "73",
      firstWord: "A",
      shouzimu: "ASNY"
    },
    {
      name: "埃塞俄比亚",
      code: "+251",
      engName: "Ethiopia",
      index: "74",
      firstWord: "A",
      shouzimu: "ASEBY"
    },
    {
      name: "爱尔兰",
      code: "+353",
      engName: "Ireland",
      index: "108",
      firstWord: "A",
      shouzimu: "AEL"
    },
    {
      name: "阿曼",
      code: "+968",
      engName: "Oman",
      index: "174",
      firstWord: "A",
      shouzimu: "AM"
    },
    {
      name: "阿克罗蒂里",
      code: "+357",
      engName: "Akrotiri",
      index: "250",
      firstWord: "A",
      shouzimu: "AKLDL"
    }
  ],
  B: [
    {
      name: "布隆迪",
      code: "+257",
      engName: "Burundi",
      index: "19",
      firstWord: "B",
      shouzimu: "BLD"
    },
    {
      name: "比利时",
      code: "+32",
      engName: "Belgium",
      index: "20",
      firstWord: "B",
      shouzimu: "BLS"
    },
    {
      name: "贝宁",
      code: "+229",
      engName: "Benin",
      index: "21",
      firstWord: "B",
      shouzimu: "BN"
    },
    {
      name: "布基纳法索",
      code: "+226",
      engName: "Burkina Faso",
      index: "22",
      firstWord: "B",
      shouzimu: "BJNFS"
    },
    {
      name: "保加利亚",
      code: "+359",
      engName: "Bulgaria",
      index: "24",
      firstWord: "B",
      shouzimu: "BJLY"
    },
    {
      name: "巴林",
      code: "+973",
      engName: "Bahrain",
      index: "25",
      firstWord: "B",
      shouzimu: "BL"
    },
    {
      name: "巴哈马",
      code: "+1242",
      engName: "Bahamas",
      index: "26",
      firstWord: "B",
      shouzimu: "BHM"
    },
    {
      name: "波斯尼亚和黑塞哥维那",
      code: "+387",
      engName: "Bosnia and Herz.",
      index: "27",
      firstWord: "B",
      shouzimu: "BSNYHHSGWN"
    },
    {
      name: "白俄罗斯",
      code: "+375",
      engName: "Belarus",
      index: "30",
      firstWord: "B",
      shouzimu: "BELS"
    },
    {
      name: "伯利兹",
      code: "+501",
      engName: "Belize",
      index: "31",
      firstWord: "B",
      shouzimu: "BLZ"
    },
    {
      name: "百慕大",
      code: "+1441",
      engName: "Bermuda",
      index: "32",
      firstWord: "B",
      shouzimu: "BMD"
    },
    {
      name: "玻利维亚",
      code: "+591",
      engName: "Bolivia",
      index: "33",
      firstWord: "B",
      shouzimu: "BLWY"
    },
    {
      name: "巴西",
      code: "+55",
      engName: "Brazil",
      index: "34",
      firstWord: "B",
      shouzimu: "BX"
    },
    {
      name: "巴巴多斯",
      code: "+1246",
      engName: "Barbados",
      index: "35",
      firstWord: "B",
      shouzimu: "BBDS"
    },
    {
      name: "不丹",
      code: "+975",
      engName: "Bhutan",
      index: "37",
      firstWord: "B",
      shouzimu: "BD"
    },
    {
      name: "博茨瓦纳",
      code: "+267",
      engName: "Botswana",
      index: "38",
      firstWord: "B",
      shouzimu: "BCWN"
    },
    {
      name: "冰岛",
      code: "+354",
      engName: "Iceland",
      index: "111",
      firstWord: "B",
      shouzimu: "BD"
    },
    {
      name: "北马里亚纳群岛",
      code: "+1670",
      engName: "N. Mariana Is.",
      index: "155",
      firstWord: "B",
      shouzimu: "BMLYNQD"
    },
    {
      name: "巴基斯坦",
      code: "+92",
      engName: "Pakistan",
      index: "175",
      firstWord: "B",
      shouzimu: "BJST"
    },
    {
      name: "巴拿马",
      code: "+507",
      engName: "Panama",
      index: "176",
      firstWord: "B",
      shouzimu: "BNM"
    },
    {
      name: "秘鲁",
      code: "+51",
      engName: "Peru",
      index: "178",
      firstWord: "B",
      shouzimu: "BL"
    },
    {
      name: "巴布亚新几内亚",
      code: "+675",
      engName: "Papua New Guinea",
      index: "182",
      firstWord: "B",
      shouzimu: "BBYXJNY"
    },
    {
      name: "波兰",
      code: "+48",
      engName: "Poland",
      index: "183",
      firstWord: "B",
      shouzimu: "BL"
    },
    {
      name: "波多黎各",
      code: "+1787",
      engName: "Puerto Rico",
      index: "184",
      firstWord: "B",
      shouzimu: "BDLG"
    },
    {
      name: "巴拉圭",
      code: "+595",
      engName: "Paraguay",
      index: "187",
      firstWord: "B",
      shouzimu: "BLG"
    },
    {
      name: "巴勒斯坦",
      code: "+970",
      engName: "Palestine",
      index: "188",
      firstWord: "B",
      shouzimu: "BLST"
    },
    {
      name: "拜科努尔",
      code: "+77",
      engName: "Baikonur",
      index: "118",
      firstWord: "B",
      shouzimu: "BKNE"
    }
  ],
  C: [
    {
      name: "赤道几内亚",
      code: "+240",
      engName: "Eq. Guinea",
      index: "90",
      firstWord: "C",
      shouzimu: "CDJNY"
    },
    {
      name: "朝鲜",
      code: "+850",
      engName: "Dem. Rep. Korea",
      index: "185",
      firstWord: "C",
      shouzimu: "CX"
    }
  ],
  D: [
    {
      name: "德国",
      code: "+49",
      engName: "Germany",
      index: "62",
      firstWord: "D",
      shouzimu: "DG"
    },
    {
      name: "多米尼克",
      code: "+1767",
      engName: "Dominica",
      index: "64",
      firstWord: "D",
      shouzimu: "DMNK"
    },
    {
      name: "丹麦",
      code: "+45",
      engName: "Denmark",
      index: "65",
      firstWord: "D",
      shouzimu: "DM"
    },
    {
      name: "多米尼加",
      code: "+1809",
      engName: "Dominican Rep.",
      index: "66",
      firstWord: "D",
      shouzimu: "DMNJ"
    },
    {
      name: "多哥",
      code: "+228",
      engName: "Togo",
      index: "223",
      firstWord: "D",
      shouzimu: "DG"
    },
    {
      name: "东帝汶",
      code: "+670",
      engName: "Timor-Leste",
      index: "227",
      firstWord: "D",
      shouzimu: "DDW"
    },
    {
      name: "德凯利亚",
      code: "+44",
      engName: "Dhekelia",
      index: "71",
      firstWord: "D",
      shouzimu: "DKLY"
    }
  ],
  E: [
    {
      name: "厄瓜多尔",
      code: "+593",
      engName: "Ecuador",
      index: "68",
      firstWord: "E",
      shouzimu: "EGDE"
    },
    {
      name: "厄立特里亚",
      code: "+291",
      engName: "Eritrea",
      index: "70",
      firstWord: "E",
      shouzimu: "ELTLY"
    },
    {
      name: "俄罗斯",
      code: "+7",
      engName: "Russia",
      index: "192",
      firstWord: "E",
      shouzimu: "ELS"
    }
  ],
  F: [
    {
      name: "佛得角",
      code: "+238",
      engName: "Cape Verde",
      index: "53",
      firstWord: "F",
      shouzimu: "FDJ"
    },
    {
      name: "芬兰",
      code: "+358",
      engName: "Finland",
      index: "75",
      firstWord: "F",
      shouzimu: "FL"
    },
    {
      name: "斐济",
      code: "+679",
      engName: "Fiji",
      index: "76",
      firstWord: "F",
      shouzimu: "FJ"
    },
    {
      name: "福克兰群岛",
      code: "+500",
      engName: "Falkland Is.",
      index: "77",
      firstWord: "F",
      shouzimu: "FKLQD"
    },
    {
      name: "法国",
      code: "+33",
      engName: "France",
      index: "78",
      firstWord: "F",
      shouzimu: "FG"
    },
    {
      name: "法罗群岛",
      code: "+298",
      engName: "Faeroe Is.",
      index: "79",
      firstWord: "F",
      shouzimu: "FLQD"
    },
    {
      name: "法属圣马丁",
      code: "+1599",
      engName: "St-Martin",
      index: "141",
      firstWord: "F",
      shouzimu: "FSSMD"
    },
    {
      name: "菲律宾",
      code: "+63",
      engName: "Philippines",
      index: "180",
      firstWord: "F",
      shouzimu: "FLB"
    },
    {
      name: "法属波利尼西亚",
      code: "+689",
      engName: "Fr. Polynesia",
      index: "189",
      firstWord: "F",
      shouzimu: "FSBLNXY"
    },
    {
      name: "梵蒂冈",
      code: "+39",
      engName: "Vatican",
      index: "242",
      firstWord: "F",
      shouzimu: "FDG"
    },
    {
      name: "法属南部领土",
      code: "+262",
      engName: "Fr. S. Antarctic Lands",
      index: "14",
      firstWord: "F",
      shouzimu: "FSNBLT"
    }
  ],
  G: [
    {
      name: "刚果(金)",
      code: "+243",
      engName: "Dem. Rep. Congo",
      index: "48",
      firstWord: "G",
      shouzimu: "GG(J)"
    },
    {
      name: "刚果(布)",
      code: "+242",
      engName: "Congo",
      index: "49",
      firstWord: "G",
      shouzimu: "GG(B)"
    },
    {
      name: "哥伦比亚",
      code: "+57",
      engName: "Colombia",
      index: "51",
      firstWord: "G",
      shouzimu: "GLBY"
    },
    {
      name: "哥斯达黎加",
      code: "+506",
      engName: "Costa Rica",
      index: "54",
      firstWord: "G",
      shouzimu: "GSDLJ"
    },
    {
      name: "古巴",
      code: "+53",
      engName: "Cuba",
      index: "56",
      firstWord: "G",
      shouzimu: "GB"
    },
    {
      name: "格鲁吉亚",
      code: "+995",
      engName: "Georgia",
      index: "83",
      firstWord: "G",
      shouzimu: "GLJY"
    },
    {
      name: "冈比亚",
      code: "+220",
      engName: "Gambia",
      index: "88",
      firstWord: "G",
      shouzimu: "GBY"
    },
    {
      name: "格林纳达",
      code: "+1473",
      engName: "Grenada",
      index: "92",
      firstWord: "G",
      shouzimu: "GLND"
    },
    {
      name: "格陵兰",
      code: "+299",
      engName: "Greenland",
      index: "93",
      firstWord: "G",
      shouzimu: "GLL"
    },
    {
      name: "关岛",
      code: "+1671",
      engName: "Guam",
      index: "95",
      firstWord: "G",
      shouzimu: "GD"
    },
    {
      name: "圭亚那",
      code: "+592",
      engName: "Guyana",
      index: "96",
      firstWord: "G",
      shouzimu: "GYN"
    },
    {
      name: "关塔那摩湾",
      code: "+1",
      engName: "USNB Guantanamo Bay",
      index: "240",
      firstWord: "G",
      shouzimu: "GTNMW"
    }
  ],
  H: [
    {
      name: "洪都拉斯",
      code: "+504",
      engName: "Honduras",
      index: "99",
      firstWord: "H",
      shouzimu: "HDLS"
    },
    {
      name: "海地",
      code: "+509",
      engName: "Haiti",
      index: "101",
      firstWord: "H",
      shouzimu: "HD"
    },
    {
      name: "哈萨克斯坦",
      code: "+327",
      engName: "Kazakhstan",
      index: "120",
      firstWord: "H",
      shouzimu: "HSKST"
    },
    {
      name: "韩国",
      code: "+82",
      engName: "Korea",
      index: "126",
      firstWord: "H",
      shouzimu: "HG"
    },
    {
      name: "黑山",
      code: "+382",
      engName: "Montenegro",
      index: "153",
      firstWord: "H",
      shouzimu: "HS"
    },
    {
      name: "荷兰",
      code: "+31",
      engName: "Netherlands",
      index: "169",
      firstWord: "H",
      shouzimu: "HL"
    },
    {
      name: "荷属圣马丁",
      code: "+1721",
      engName: "Sint Maarten",
      index: "218",
      firstWord: "H",
      shouzimu: "HSSMD"
    },
    {
      name: "赫德岛和麦克唐纳岛",
      code: "+672",
      engName: "Heard I. and McDonald Is.",
      index: "98",
      firstWord: "H",
      shouzimu: "HDDHMKTND"
    }
  ],
  J: [
    {
      name: "加拿大",
      code: "+1",
      engName: "Canada",
      index: "40",
      firstWord: "J",
      shouzimu: "JND"
    },
    {
      name: "捷克",
      code: "+420",
      engName: "Czech Rep.",
      index: "61",
      firstWord: "J",
      shouzimu: "JK"
    },
    {
      name: "吉布提",
      code: "+253",
      engName: "Djibouti",
      index: "63",
      firstWord: "J",
      shouzimu: "JBT"
    },
    {
      name: "加蓬",
      code: "+241",
      engName: "Gabon",
      index: "81",
      firstWord: "J",
      shouzimu: "JP"
    },
    {
      name: "加纳",
      code: "+233",
      engName: "Ghana",
      index: "85",
      firstWord: "J",
      shouzimu: "JN"
    },
    {
      name: "几内亚",
      code: "+224",
      engName: "Guinea",
      index: "87",
      firstWord: "J",
      shouzimu: "JNY"
    },
    {
      name: "几内亚比绍",
      code: "+245",
      engName: "Guinea-Bissau",
      index: "89",
      firstWord: "J",
      shouzimu: "JNYBS"
    },
    {
      name: "吉尔吉斯斯坦",
      code: "+331",
      engName: "Kyrgyzstan",
      index: "122",
      firstWord: "J",
      shouzimu: "JEJSST"
    },
    {
      name: "柬埔寨",
      code: "+855",
      engName: "Cambodia",
      index: "123",
      firstWord: "J",
      shouzimu: "JPZ"
    },
    {
      name: "基里巴斯",
      code: "+686",
      engName: "Kiribati",
      index: "124",
      firstWord: "J",
      shouzimu: "JLBS"
    },
    {
      name: "津巴布韦",
      code: "+263",
      engName: "Zimbabwe",
      index: "255",
      firstWord: "J",
      shouzimu: "JBBW"
    }
  ],
  K: [
    {
      name: "科特迪瓦",
      code: "+225",
      engName: "Côte d'Ivoire",
      index: "44",
      firstWord: "K",
      shouzimu: "KTDW"
    },
    {
      name: "喀麦隆",
      code: "+237",
      engName: "Cameroon",
      index: "46",
      firstWord: "K",
      shouzimu: "KML"
    },
    {
      name: "库克群岛",
      code: "+682",
      engName: "Cook Is.",
      index: "50",
      firstWord: "K",
      shouzimu: "KKQD"
    },
    {
      name: "科摩罗",
      code: "+269",
      engName: "Comoros",
      index: "52",
      firstWord: "K",
      shouzimu: "KML"
    },
    {
      name: "库拉索",
      code: "+5999",
      engName: "Curaçao",
      index: "57",
      firstWord: "K",
      shouzimu: "KLS"
    },
    {
      name: "开曼群岛",
      code: "+1345",
      engName: "Cayman Is.",
      index: "58",
      firstWord: "K",
      shouzimu: "KMQD"
    },
    {
      name: "克罗地亚",
      code: "+385",
      engName: "Croatia",
      index: "100",
      firstWord: "K",
      shouzimu: "KLDY"
    },
    {
      name: "肯尼亚",
      code: "+254",
      engName: "Kenya",
      index: "121",
      firstWord: "K",
      shouzimu: "KNY"
    },
    {
      name: "科索沃",
      code: "+384",
      engName: "Kosovo",
      index: "127",
      firstWord: "K",
      shouzimu: "KSW"
    },
    {
      name: "科威特",
      code: "+965",
      engName: "Kuwait",
      index: "128",
      firstWord: "K",
      shouzimu: "KWT"
    },
    {
      name: "卡塔尔",
      code: "+974",
      engName: "Qatar",
      index: "190",
      firstWord: "K",
      shouzimu: "KTE"
    },
    {
      name: "克利珀顿岛",
      code: "+262",
      engName: "Clipperton I.",
      index: "45",
      firstWord: "K",
      shouzimu: "KLPDD"
    }
  ],
  L: [
    {
      name: "老挝",
      code: "+856",
      engName: "Lao PDR",
      index: "129",
      firstWord: "L",
      shouzimu: "LW"
    },
    {
      name: "黎巴嫩",
      code: "+961",
      engName: "Lebanon",
      index: "130",
      firstWord: "L",
      shouzimu: "LBN"
    },
    {
      name: "利比里亚",
      code: "+231",
      engName: "Liberia",
      index: "131",
      firstWord: "L",
      shouzimu: "LBLY"
    },
    {
      name: "利比亚",
      code: "+218",
      engName: "Libya",
      index: "132",
      firstWord: "L",
      shouzimu: "LBY"
    },
    {
      name: "列支敦士登",
      code: "+423",
      engName: "Liechtenstein",
      index: "134",
      firstWord: "L",
      shouzimu: "LZDSD"
    },
    {
      name: "莱索托",
      code: "+266",
      engName: "Lesotho",
      index: "136",
      firstWord: "L",
      shouzimu: "LST"
    },
    {
      name: "立陶宛",
      code: "+370",
      engName: "Lithuania",
      index: "137",
      firstWord: "L",
      shouzimu: "LTW"
    },
    {
      name: "卢森堡",
      code: "+352",
      engName: "Luxembourg",
      index: "138",
      firstWord: "L",
      shouzimu: "LSB"
    },
    {
      name: "拉脱维亚",
      code: "+371",
      engName: "Latvia",
      index: "139",
      firstWord: "L",
      shouzimu: "LTWY"
    },
    {
      name: "罗马尼亚",
      code: "+40",
      engName: "Romania",
      index: "191",
      firstWord: "L",
      shouzimu: "LMNY"
    },
    {
      name: "卢旺达",
      code: "+250",
      engName: "Rwanda",
      index: "193",
      firstWord: "L",
      shouzimu: "LWD"
    }
  ],
  M: [
    {
      name: "美属萨摩亚",
      code: "+1684",
      engName: "American Samoa",
      index: "11",
      firstWord: "M",
      shouzimu: "MSSMY"
    },
    {
      name: "孟加拉",
      code: "+880",
      engName: "Bangladesh",
      index: "23",
      firstWord: "M",
      shouzimu: "MJL"
    },
    {
      name: "密克罗尼西亚联邦",
      code: "+691",
      engName: "Micronesia",
      index: "80",
      firstWord: "M",
      shouzimu: "MKLNXYLB"
    },
    {
      name: "摩洛哥",
      code: "+212",
      engName: "Morocco",
      index: "142",
      firstWord: "M",
      shouzimu: "MLG"
    },
    {
      name: "摩纳哥",
      code: "+377",
      engName: "Monaco",
      index: "143",
      firstWord: "M",
      shouzimu: "MNG"
    },
    {
      name: "摩尔多瓦",
      code: "+373",
      engName: "Moldova",
      index: "144",
      firstWord: "M",
      shouzimu: "MEDW"
    },
    {
      name: "马达加斯加",
      code: "+261",
      engName: "Madagascar",
      index: "145",
      firstWord: "M",
      shouzimu: "MDJSJ"
    },
    {
      name: "马尔代夫",
      code: "+960",
      engName: "Maldives",
      index: "146",
      firstWord: "M",
      shouzimu: "MEDF"
    },
    {
      name: "墨西哥",
      code: "+52",
      engName: "Mexico",
      index: "147",
      firstWord: "M",
      shouzimu: "MXG"
    },
    {
      name: "马绍尔群岛",
      code: "+692",
      engName: "Marshall Is.",
      index: "148",
      firstWord: "M",
      shouzimu: "MSEQD"
    },
    {
      name: "马其顿",
      code: "+389",
      engName: "Macedonia",
      index: "149",
      firstWord: "M",
      shouzimu: "MQD"
    },
    {
      name: "马里",
      code: "+223",
      engName: "Mali",
      index: "150",
      firstWord: "M",
      shouzimu: "ML"
    },
    {
      name: "马耳他",
      code: "+356",
      engName: "Malta",
      index: "151",
      firstWord: "M",
      shouzimu: "MET"
    },
    {
      name: "缅甸",
      code: "+95",
      engName: "Myanmar",
      index: "152",
      firstWord: "M",
      shouzimu: "MD"
    },
    {
      name: "蒙古",
      code: "+976",
      engName: "Mongolia",
      index: "154",
      firstWord: "M",
      shouzimu: "MG"
    },
    {
      name: "莫桑比克",
      code: "+258",
      engName: "Mozambique",
      index: "156",
      firstWord: "M",
      shouzimu: "MSBK"
    },
    {
      name: "毛里塔尼亚",
      code: "+222",
      engName: "Mauritania",
      index: "157",
      firstWord: "M",
      shouzimu: "MLTNY"
    },
    {
      name: "蒙塞拉特岛",
      code: "+1664",
      engName: "Montserrat",
      index: "158",
      firstWord: "M",
      shouzimu: "MSLTD"
    },
    {
      name: "毛里求斯",
      code: "+230",
      engName: "Mauritius",
      index: "159",
      firstWord: "M",
      shouzimu: "MLQS"
    },
    {
      name: "马拉维",
      code: "+265",
      engName: "Malawi",
      index: "160",
      firstWord: "M",
      shouzimu: "MLW"
    },
    {
      name: "马来西亚",
      code: "+60",
      engName: "Malaysia",
      index: "161",
      firstWord: "M",
      shouzimu: "MLXY"
    },
    {
      name: "美国",
      code: "+1",
      engName: "United States",
      index: "239",
      firstWord: "M",
      shouzimu: "MG"
    },
    {
      name: "美属维尔京群岛",
      code: "+1340",
      engName: "U.S. Virgin Is.",
      index: "246",
      firstWord: "M",
      shouzimu: "MSWEJQD"
    },
    {
      name: "美国本土外小岛屿",
      code: "+1",
      engName: "U.S. Minor Outlying Is.",
      index: "237",
      firstWord: "M",
      shouzimu: "MGBTWXDY"
    }
  ],
  N: [
    {
      name: "南极洲",
      code: "+672",
      engName: "Antarctica",
      index: "12",
      firstWord: "N",
      shouzimu: "NJZ"
    },
    {
      name: "纳米比亚",
      code: "+264",
      engName: "Namibia",
      index: "162",
      firstWord: "N",
      shouzimu: "NMBY"
    },
    {
      name: "尼日尔",
      code: "+227",
      engName: "Niger",
      index: "164",
      firstWord: "N",
      shouzimu: "NRE"
    },
    {
      name: "诺福克岛",
      code: "+672",
      engName: "Norfolk Island",
      index: "165",
      firstWord: "N",
      shouzimu: "NFKD"
    },
    {
      name: "尼日利亚",
      code: "+234",
      engName: "Nigeria",
      index: "166",
      firstWord: "N",
      shouzimu: "NRLY"
    },
    {
      name: "尼加拉瓜",
      code: "+505",
      engName: "Nicaragua",
      index: "167",
      firstWord: "N",
      shouzimu: "NJLG"
    },
    {
      name: "纽埃岛",
      code: "+683",
      engName: "Niue",
      index: "168",
      firstWord: "N",
      shouzimu: "NAD"
    },
    {
      name: "挪威",
      code: "+47",
      engName: "Norway",
      index: "170",
      firstWord: "N",
      shouzimu: "NW"
    },
    {
      name: "尼泊尔",
      code: "+977",
      engName: "Nepal",
      index: "171",
      firstWord: "N",
      shouzimu: "NBE"
    },
    {
      name: "瑙鲁",
      code: "+674",
      engName: "Nauru",
      index: "172",
      firstWord: "N",
      shouzimu: "NL"
    },
    {
      name: "南苏丹",
      code: "+211",
      engName: "S. Sudan",
      index: "198",
      firstWord: "N",
      shouzimu: "NSD"
    },
    {
      name: "南非",
      code: "+27",
      engName: "South Africa",
      index: "253",
      firstWord: "N",
      shouzimu: "NF"
    },
    {
      name: "南沙群岛",
      code: "+86",
      engName: "pratly Is.",
      index: "179",
      firstWord: "N",
      shouzimu: "NSQD"
    },
    {
      name: "南乔治亚岛和南桑德韦奇岛",
      code: "+1",
      engName: "S. Geo. and S. Sandw. Is.",
      index: "202",
      firstWord: "N",
      shouzimu: "NQZYDHNSDWQD"
    }
  ],
  P: [
    {
      name: "帕劳",
      code: "+680",
      engName: "Palau",
      index: "181",
      firstWord: "P",
      shouzimu: "PL"
    },
    {
      name: "葡萄牙",
      code: "+351",
      engName: "Portugal",
      index: "186",
      firstWord: "P",
      shouzimu: "PTY"
    },
    {
      name: "皮特克恩岛",
      code: "+1",
      engName: "Pitcairn Is.",
      index: "177",
      firstWord: "P",
      shouzimu: "PTKED"
    }
  ],
  R: [
    {
      name: "瑞士",
      code: "+41",
      engName: "Switzerland",
      index: "41",
      firstWord: "R",
      shouzimu: "RS"
    },
    {
      name: "日本",
      code: "+81",
      engName: "Japan",
      index: "117",
      firstWord: "R",
      shouzimu: "RB"
    },
    {
      name: "瑞典",
      code: "+46",
      engName: "Sweden",
      index: "216",
      firstWord: "R",
      shouzimu: "RD"
    }
  ],
  S: [
    {
      name: "圣巴泰勒米岛",
      code: "+290",
      engName: "St-Barthélemy",
      index: "29",
      firstWord: "S",
      shouzimu: "SBTLMD"
    },
    {
      name: "塞浦路斯",
      code: "+357",
      engName: "Cyprus",
      index: "60",
      firstWord: "S",
      shouzimu: "SPLS"
    },
    {
      name: "圣基茨和尼维斯",
      code: "+1869",
      engName: "St. Kitts and Nevis",
      index: "125",
      firstWord: "S",
      shouzimu: "SJCHNWS"
    },
    {
      name: "圣卢西亚",
      code: "+1758",
      engName: "Saint Lucia",
      index: "133",
      firstWord: "S",
      shouzimu: "SLXY"
    },
    {
      name: "斯里兰卡",
      code: "+94",
      engName: "Sri Lanka",
      index: "135",
      firstWord: "S",
      shouzimu: "SLLK"
    },
    {
      name: "沙特阿拉伯",
      code: "+966",
      engName: "Saudi Arabia",
      index: "195",
      firstWord: "S",
      shouzimu: "STALB"
    },
    {
      name: "苏丹",
      code: "+249",
      engName: "Sudan",
      index: "197",
      firstWord: "S",
      shouzimu: "SD"
    },
    {
      name: "塞内加尔",
      code: "+221",
      engName: "Senegal",
      index: "199",
      firstWord: "S",
      shouzimu: "SNJE"
    },
    {
      name: "所罗门群岛",
      code: "+677",
      engName: "Solomon Is.",
      index: "204",
      firstWord: "S",
      shouzimu: "SLMQD"
    },
    {
      name: "塞拉利昂",
      code: "+232",
      engName: "Sierra Leone",
      index: "205",
      firstWord: "S",
      shouzimu: "SLLA"
    },
    {
      name: "萨尔瓦多",
      code: "+503",
      engName: "El Salvador",
      index: "206",
      firstWord: "S",
      shouzimu: "SEWD"
    },
    {
      name: "圣马力诺",
      code: "+378",
      engName: "San Marino",
      index: "207",
      firstWord: "S",
      shouzimu: "SMLN"
    },
    {
      name: "索马里",
      code: "+252",
      engName: "Somalia",
      index: "209",
      firstWord: "S",
      shouzimu: "SML"
    },
    {
      name: "圣皮埃尔和密克隆群岛",
      code: "+508",
      engName: "St. Pierre and Miquelon",
      index: "210",
      firstWord: "S",
      shouzimu: "SPAEHMKLQD"
    },
    {
      name: "塞尔维亚",
      code: "+381",
      engName: "Serbia",
      index: "211",
      firstWord: "S",
      shouzimu: "SEWY"
    },
    {
      name: "圣多美和普林西比",
      code: "+239",
      engName: "São Tomé and Principe",
      index: "212",
      firstWord: "S",
      shouzimu: "SDMHPLXB"
    },
    {
      name: "苏里南",
      code: "+597",
      engName: "Suriname",
      index: "213",
      firstWord: "S",
      shouzimu: "SLN"
    },
    {
      name: "斯洛伐克",
      code: "+421",
      engName: "Slovakia",
      index: "214",
      firstWord: "S",
      shouzimu: "SLFK"
    },
    {
      name: "斯洛文尼亚",
      code: "+386",
      engName: "Slovenia",
      index: "215",
      firstWord: "S",
      shouzimu: "SLWNY"
    },
    {
      name: "斯威士兰",
      code: "+268",
      engName: "Swaziland",
      index: "217",
      firstWord: "S",
      shouzimu: "SWSL"
    },
    {
      name: "塞舌尔",
      code: "+248",
      engName: "Seychelles",
      index: "219",
      firstWord: "S",
      shouzimu: "SSE"
    },
    {
      name: "圣文森特和格林纳丁斯",
      code: "+1784",
      engName: "St. Vin. and Gren.",
      index: "243",
      firstWord: "S",
      shouzimu: "SWSTHGLNDS"
    },
    {
      name: "萨摩亚",
      code: "+685",
      engName: "Samoa",
      index: "251",
      firstWord: "S",
      shouzimu: "SMY"
    },
    {
      name: "塞浦路斯联合国缓冲区",
      code: "+357",
      engName: "Cyprus U.N. Buffer Zone",
      index: "47",
      firstWord: "S",
      shouzimu: "SPLSLHGHCQ"
    },
    {
      name: "珊瑚海群岛",
      code: "+43",
      engName: "Coral Sea Is.",
      index: "55",
      firstWord: "S",
      shouzimu: "SHHQD"
    },
    {
      name: "圣赫勒拿",
      code: "+1",
      engName: "Saint Helena",
      index: "203",
      firstWord: "S",
      shouzimu: "SHLN"
    },
    {
      name: "索马里兰",
      code: "+252",
      engName: "Somaliland",
      index: "208",
      firstWord: "S",
      shouzimu: "SMLL"
    }
  ],
  T: [
    {
      name: "特克斯和凯科斯群岛",
      code: "+1649",
      engName: "Turks and Caicos Is.",
      index: "221",
      firstWord: "T",
      shouzimu: "TKSHKKSQD"
    },
    {
      name: "泰国",
      code: "+66",
      engName: "Thailand",
      index: "224",
      firstWord: "T",
      shouzimu: "TG"
    },
    {
      name: "塔吉克斯坦",
      code: "+992",
      engName: "Tajikistan",
      index: "225",
      firstWord: "T",
      shouzimu: "TJKST"
    },
    {
      name: "土库曼斯坦",
      code: "+993",
      engName: "Turkmenistan",
      index: "226",
      firstWord: "T",
      shouzimu: "TKMST"
    },
    {
      name: "汤加",
      code: "+676",
      engName: "Tonga",
      index: "228",
      firstWord: "T",
      shouzimu: "TJ"
    },
    {
      name: "特立尼达和多巴哥",
      code: "+1868",
      engName: "Trinidad and Tobago",
      index: "229",
      firstWord: "T",
      shouzimu: "TLNDHDBG"
    },
    {
      name: "突尼斯",
      code: "+216",
      engName: "Tunisia",
      index: "230",
      firstWord: "T",
      shouzimu: "TNS"
    },
    {
      name: "土耳其",
      code: "+90",
      engName: "Turkey",
      index: "231",
      firstWord: "T",
      shouzimu: "TEQ"
    },
    {
      name: "图瓦卢",
      code: "+688",
      engName: "Tuvalu",
      index: "232",
      firstWord: "T",
      shouzimu: "TWL"
    },
    {
      name: "坦桑尼亚",
      code: "+255",
      engName: "Tanzania",
      index: "234",
      firstWord: "T",
      shouzimu: "TSNY"
    }
  ],
  W: [
    {
      name: "文莱",
      code: "+673",
      engName: "Brunei",
      index: "36",
      firstWord: "W",
      shouzimu: "WL"
    },
    {
      name: "危地马拉",
      code: "+502",
      engName: "Guatemala",
      index: "94",
      firstWord: "W",
      shouzimu: "WDML"
    },
    {
      name: "乌干达",
      code: "+256",
      engName: "Uganda",
      index: "235",
      firstWord: "W",
      shouzimu: "WGD"
    },
    {
      name: "乌克兰",
      code: "+380",
      engName: "Ukraine",
      index: "236",
      firstWord: "W",
      shouzimu: "WKL"
    },
    {
      name: "乌拉圭",
      code: "+598",
      engName: "Uruguay",
      index: "238",
      firstWord: "W",
      shouzimu: "WLG"
    },
    {
      name: "乌兹别克斯坦",
      code: "+233",
      engName: "Uzbekistan",
      index: "241",
      firstWord: "W",
      shouzimu: "WZBKST"
    },
    {
      name: "委内瑞拉",
      code: "+58",
      engName: "Venezuela",
      index: "244",
      firstWord: "W",
      shouzimu: "WNRL"
    },
    {
      name: "瓦努阿图",
      code: "+678",
      engName: "Vanuatu",
      index: "248",
      firstWord: "W",
      shouzimu: "WNAT"
    },
    {
      name: "瓦利斯和富图纳群岛",
      code: "+681",
      engName: "Wallis and Futuna Is.",
      index: "249",
      firstWord: "W",
      shouzimu: "WLSHFTNQD"
    }
  ],
  X: [
    {
      name: "西班牙",
      code: "+34",
      engName: "Spain",
      index: "72",
      firstWord: "X",
      shouzimu: "XBY"
    },
    {
      name: "希腊",
      code: "+30",
      engName: "Greece",
      index: "91",
      firstWord: "X",
      shouzimu: "XL"
    },
    {
      name: "匈牙利",
      code: "+36",
      engName: "Hungary",
      index: "102",
      firstWord: "X",
      shouzimu: "XYL"
    },
    {
      name: "新喀里多尼亚",
      code: "+687",
      engName: "New Caledonia",
      index: "163",
      firstWord: "X",
      shouzimu: "XKLDNY"
    },
    {
      name: "新西兰",
      code: "+64",
      engName: "New Zealand",
      index: "173",
      firstWord: "X",
      shouzimu: "XXL"
    },
    {
      name: "新加坡",
      code: "+65",
      engName: "Singapore",
      index: "201",
      firstWord: "X",
      shouzimu: "XJP"
    },
    {
      name: "叙利亚",
      code: "+963",
      engName: "Syria",
      index: "220",
      firstWord: "X",
      shouzimu: "XLY"
    },
    {
      name: "西撒哈拉",
      code: "+212",
      engName: "W. Sahara",
      index: "194",
      firstWord: "X",
      shouzimu: "XSHL"
    }
  ],
  Y: [
    {
      name: "亚美尼亚",
      code: "+374",
      engName: "Armenia",
      index: "10",
      firstWord: "Y",
      shouzimu: "YMNY"
    },
    {
      name: "英国",
      code: "+44",
      engName: "United Kingdom",
      index: "82",
      firstWord: "Y",
      shouzimu: "YG"
    },
    {
      name: "印度尼西亚",
      code: "+62",
      engName: "Indonesia",
      index: "103",
      firstWord: "Y",
      shouzimu: "YDNXY"
    },
    {
      name: "印度",
      code: "+91",
      engName: "India",
      index: "105",
      firstWord: "Y",
      shouzimu: "YD"
    },
    {
      name: "英属印度洋领地",
      code: "+246",
      engName: "Br. Indian Ocean Ter.",
      index: "107",
      firstWord: "Y",
      shouzimu: "YSYDYLD"
    },
    {
      name: "伊朗",
      code: "+98",
      engName: "Iran",
      index: "109",
      firstWord: "Y",
      shouzimu: "YL"
    },
    {
      name: "伊拉克",
      code: "+964",
      engName: "Iraq",
      index: "110",
      firstWord: "Y",
      shouzimu: "YLK"
    },
    {
      name: "以色列",
      code: "+972",
      engName: "Israel",
      index: "112",
      firstWord: "Y",
      shouzimu: "YSL"
    },
    {
      name: "意大利",
      code: "+39",
      engName: "Italy",
      index: "113",
      firstWord: "Y",
      shouzimu: "YDL"
    },
    {
      name: "牙买加",
      code: "+1876",
      engName: "Jamaica",
      index: "114",
      firstWord: "Y",
      shouzimu: "YMJ"
    },
    {
      name: "约旦",
      code: "+962",
      engName: "Jordan",
      index: "116",
      firstWord: "Y",
      shouzimu: "YD"
    },
    {
      name: "英属维尔京群岛",
      code: "+1284",
      engName: "British Virgin Is.",
      index: "245",
      firstWord: "Y",
      shouzimu: "YSWEJQD"
    },
    {
      name: "越南",
      code: "+84",
      engName: "Vietnam",
      index: "247",
      firstWord: "Y",
      shouzimu: "YN"
    },
    {
      name: "也门",
      code: "+967",
      engName: "Yemen",
      index: "252",
      firstWord: "Y",
      shouzimu: "YM"
    },
    {
      name: "亚什摩及卡地尔群岛",
      code: "+61",
      engName: "Ashmore and Cartier Is.",
      index: "13",
      firstWord: "Y",
      shouzimu: "YSMJKDEQD"
    },
    {
      name: "印度洋领地",
      code: "+246",
      engName: "Indian Ocean Ter.",
      index: "106",
      firstWord: "Y",
      shouzimu: "YDYLD"
    }
  ],
  Z: [
    {
      name: "中非",
      code: "+236",
      engName: "Central African Rep.",
      index: "39",
      firstWord: "Z",
      shouzimu: "ZF"
    },
    {
      name: "智利",
      code: "+56",
      engName: "Chile",
      index: "42",
      firstWord: "Z",
      shouzimu: "ZL"
    },
    {
      name: "中国",
      code: "+86",
      engName: "China",
      index: "43",
      firstWord: "Z",
      shouzimu: "ZGDL",
      hot: true
    },
    {
      name: "直布罗陀",
      code: "+350",
      engName: "Gibraltar",
      index: "86",
      firstWord: "Z",
      shouzimu: "ZBLT"
    },
    {
      name: "乍得",
      code: "+235",
      engName: "Chad",
      index: "222",
      firstWord: "Z",
      shouzimu: "ZD"
    },
    {
      name: "赞比亚",
      code: "+260",
      engName: "Zambia",
      index: "254",
      firstWord: "Z",
      shouzimu: "ZBY"
    },
    {
      name: "中国香港",
      code: "+852",
      engName: "Hong Kong",
      index: "97",
      firstWord: "Z",
      shouzimu: "ZGXG",
      hot: true
    },
    {
      name: "中国澳门",
      code: "+853",
      engName: "Macao",
      index: "140",
      firstWord: "Z",
      shouzimu: "ZGAM",
      hot: true
    },
    {
      name: "中国台湾",
      code: "+886",
      engName: "Taiwan",
      index: "233",
      firstWord: "Z",
      shouzimu: "ZGTW",
      hot: true
    }
  ]
};



// WEBPACK FOOTER //
// ./src/utils/areaCode.js